
























































import { defineComponent, computed } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import TTIcon from '@tt4b/ttam-assets/src/svgs/creative/tt-account-icon.svg';
import { i18n } from './../../../../i18n';
import VueI18n from 'vue-i18n';
import { trackEvent } from './../../../../utils/index';
import { useStore } from '@tt4b/ttam-hooks';

enum AuthorizeType {
  /** 1v1 */
  BA = 'BA',
  /** NvN */
  BC = 'BC',
}

const name = 'identity-initial';
export default defineComponent({
  name,
  components: {
    TTIcon,
    QuestionTooltip,
  },
  props: {
    isSupportBCNvN: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    linkText: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const onLink = () => {
      emit('link');
    };
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value?.aadvid ?? '');
    const authorizationList = computed<
      {
        label: VueI18n.TranslateResult;
        tooltip: VueI18n.TranslateResult;
        value: AuthorizeType;
      }[]
    >(() => [
      {
        label: i18n.t('creative_identity_anchor_authorize1v1'),
        tooltip: i18n.t('creative_identity_description_authorize1v1'),
        value: AuthorizeType.BA,
      },
      {
        label: i18n.t('creative_identity_anchor_authorizeNvN'),
        tooltip: i18n.t('creative_identity_description_authorizeNvN'),
        value: AuthorizeType.BC,
      },
    ]);

    const gotoAutorize = (authorizeType: AuthorizeType) => {
      if (authorizeType === AuthorizeType.BA) {
        trackEvent('creative_identity_bind_ttba_start');
        emit('link');
      } else {
        trackEvent('creative_identity_bind_ttbc_start');
        window.open(
          `https://business.tiktok.com/select?ttam_id=${aadvid.value}&action=tiktok&request_role=1`,
          '_blank',
        );
      }
    };

    return {
      name,
      authorizationList,
      gotoAutorize,
      onLink,
    };
  },
});
